/*
 * @Descripttion: 
 * @version: 
 * @@Company: DCIT-SH
 * @Author: Boyf
 * @Date: 2022-07-05 16:05:44
 * @LastEditors: Boyf
 * @LastEditTime: 2022-10-26 11:05:07
 */
import Vue from 'vue'
import Router from 'vue-router'

const login = () => import("@/view/Login")
const preview = () => import("@/view/preview")
const previewcfca = () => import("@/view/preview_cfca")
const previewls = () => import("@/view/preview_ls")
const preview_pdf = () => import("@/view/previewpdf")
const workbench = () => import("@/view/workbech")
const lct = () => import("@/view/ademo/lctd")
const pdf_show = () => import("@/view/pdfShow")
const special = () => import("@/view/special")
const noneView = () => import("@/view/404.vue")
const videoHelpPage = () => import("@/view/videoHelpPage")
import indexRouter from './src/main'
import projectEntryRouter from './src/projectEntry'

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err);
}

Vue.use(Router)

export default new Router({
  routes: [{
    path: '*',
    redirect: '/login'
  },
  {
    path: '/preview/:show?',
    name: 'preview',
    component: preview,
  },
  {
    path: '/previewcfca',
    name: 'previewcfca',
    component: previewcfca,
  },
  {
    path: '/previewls',
    name: 'previewls',
    component: previewls,
  },
  {
    path: '/previewpdf/:show?',  // 使用cafe-pdf插件实现的pdf在线预览公共组件路由
    name: 'preview_pdf',
    component: preview_pdf,
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    },
    {
      path: '/videoHelpPage',
      name: 'videoHelpPage',
      component: videoHelpPage
  },
  {
    path: '/workbench',
    name: 'workbench',
    component: workbench,
  },

  {
    path: '/lct',
    name: 'lct',
    component: lct,
  },

  {
    path: '/pdf-show',
    name: 'pdf-show',
    component: pdf_show,
  },
  {
    path: '/special',
    name: 'special',
    component: special,
  },
  {
    path: '/404',
    name: '404',
    component: noneView
  },
    indexRouter,
    projectEntryRouter
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js